var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tabType)?_c(_vm.tabType,{tag:"components"}):_c('carDetail',{attrs:{"tabName":_vm.activeName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }